import { render } from "./HeroListShowDetail.vue?vue&type=template&id=5bcca656&scoped=true"
import script from "./HeroListShowDetail.vue?vue&type=script&lang=js"
export * from "./HeroListShowDetail.vue?vue&type=script&lang=js"

import "./HeroListShowDetail.vue?vue&type=style&index=0&id=5bcca656&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcca656"]])

export default __exports__